import React, { useContext } from "react";
import { StoreContext } from "../context/Store";
import AddSelectBlock from "../parts/AddSelectBlock";
import Button from "../parts/Button";
import SearchSelectBlock from "../parts/SearchSelectBlock";
import Text from "../parts/Text";

export interface SkillsProps {}

export interface SkillsState {}

export const Skills = React.forwardRef<HTMLDivElement, SkillsProps>(
  (props, ref) => {
    const store = useContext(StoreContext);
    const { skills, toggleSkill, tempSkill, addSkill, setTempSkill } = store;
    return (
      <section id="skills" ref={ref}>
        <Text tag="h2" color="pink" classes="mb-5">
          Umiejętności
        </Text>
        <Text tag="p" classes="mb-5">
          To bardzo ważna część CV! To tu możesz nadrobić braki w doświadczeniu.{" "}
          <strong className="blue">
            Zastanów się, w czym jesteś naprawdę dobry.{" "}
          </strong>
          Umiesz logicznie myśleć i wyciągać wnioski? Potrafisz być świetnym
          organizatorem? Lubisz szukać niestandardowych rozwiązań? A może
          skrupulatność to Twoje drugie imię? Wybierz propozycje z listy albo
          dopisz własne.{" "}
          <strong className="blue">
            Podkreśl to, co łatwo udowodnisz podając przykłady z życia
            codziennego.
          </strong>
        </Text>
        <SearchSelectBlock search data={skills} toggleAction={toggleSkill}>
          <AddSelectBlock
            value={tempSkill}
            add={addSkill}
            onChange={setTempSkill}
            placeholder="Inna (wpisz jaka)"
          />
        </SearchSelectBlock>
        <div className="d-flex justify-content-end mb-5">
          <Button
            onClick={addSkill}
            classes="smaller-text pink-border"
            disabled={tempSkill.length < 3}
          >
            dodaj
          </Button>
        </div>
      </section>
    );
  }
);

export default Skills;
